module.exports = __webpack_public_path__ + "img/saic-logo.c0d8f36c.svg";